import { EducationalLevel, Region } from '@/types/contest'

// Constants
const educationItems: { id: EducationalLevel; label: string }[] = [
  { id: 'PRIMARY', label: 'ประถม' },
  { id: 'MIDDLE', label: 'มัธยมต้น' },
  { id: 'HIGH', label: 'มัธยมปลาย' },
  { id: 'BACHELOR', label: 'ปริญญาตรี' },
  { id: 'MASTER', label: 'ปริญญาโท' },
  { id: 'PHD', label: 'ปริญญาเอก' },
  { id: 'ANY', label: 'ไม่จำกัด' },
]

const regionItems: { id: Region; label: string }[] = [
  { id: 'BANGKOK_METROPOLITAN', label: 'กรุงเทพฯ ปริมณฑล' },
  { id: 'CENTRAL', label: 'ภาคกลาง' },
  { id: 'NORTHERN', label: 'ภาคเหนือ' },
  { id: 'NORTH_EASTERN', label: 'ภาคอีสาน' },
  { id: 'EASTERN', label: 'ภาคตะวันออก' },
  { id: 'WESTERN', label: 'ภาคตะวันตก' },
  { id: 'SOUTHERN', label: 'ภาคใต้' },
]

type MemberType = 'SINGLE' | 'TEAM'
interface GroupNumber {
  id: MemberType
  label: string
}

const memberItems: GroupNumber[] = [
  { id: 'SINGLE', label: 'แข่งเดี่ยว' },
  { id: 'TEAM', label: 'แข่งกลุ่ม' },
]

const rewardTypes = [
  { id: 'general_prize', label: 'เงินรางวัล' },
  { id: 'seed_funding_prize', label: 'ทุนพัฒนาผลงาน' },
  { id: 'workshop_special_course_prize', label: 'เวิร์กชอป / คอร์สพิเศษ' },
  { id: 'special_visit', label: 'ศึกษาดูงาน' },
  { id: 'overseas', label: 'เดินทางต่างประเทศ' },
]

const opportunityTypes = [
  { id: 'certificate', label: 'เกียรติบัตร' },
  { id: 'trophy', label: 'เหรียญ / โล่รางวัล' },
  { id: 'internship', label: 'ฝึกงาน' },
  { id: 'publish_work', label: 'เผยแพร่ผลงาน' },
  { id: 'company_partnership', label: 'ร่วมงานกับบริษัท' },
]

export {
  educationItems,
  regionItems,
  memberItems,
  rewardTypes,
  opportunityTypes,
}

export type { MemberType, GroupNumber }
